export enum SelfTriageScreenEnum {
    welcome = 1,
    orientations = 2,
    identification = 3,
    personalData = 4,
    evaluation = 5,
    counseling = 6,
    end = 7,
}